import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountPreferencesComponent } from '../AccountPreferences/components/AccountPreferences/account-preferences.component';
import { DataConnectorComponent } from '../components/DataConnector/data-connector.component';
import { FileDownloadsComponent } from '../components/FileDownloads/file-downloads.component';
import { UserPreferencesComponent } from '../UserPreferences/components/UserPreferences/user-preferences.component';
import { SsoManagementComponent } from '../components/SsoManagement/sso-management.component';
import { EmailAccountConnectorComponent } from '../components/EmailAccountConnector/email-account-connector.component';

const accountRoutes: Routes = [
    {
        path: 'UserPreferences',
        component: UserPreferencesComponent
    },
    {
        path: 'AccountPrefs',
        component: AccountPreferencesComponent
    },
    {
        path: 'DataConnector',
        component: DataConnectorComponent
    },
    {
        path: 'FileDownloads',
        component: FileDownloadsComponent
    },
    {
        path: 'AuthManagement',
        component: SsoManagementComponent
    },
    {
        path: 'EmailAccountConnector/code',
        component: EmailAccountConnectorComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(accountRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class AccountRoutingModule { }
